module.exports = __webpack_public_path__ + "static/media/sidd_logo4.226f5737.png";